"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllDayEventCoordinateCoder = void 0;
const date_fns_1 = require("date-fns");
class AllDayEventCoordinateCoder {
    static encode(allDayEvent, config) {
        const daysFromCurrentPagePeriodStart = (0, date_fns_1.differenceInDays)(allDayEvent.event.period.start, config.originDate);
        const dayLength = allDayEvent.event.period.lengthInDays() + 1;
        return {
            height: config.dayEventHeight,
            width: dayLength * config.widthPerDay,
            top: allDayEvent.rowIndex * config.dayEventHeight,
            left: daysFromCurrentPagePeriodStart * config.widthPerDay
        };
    }
}
exports.AllDayEventCoordinateCoder = AllDayEventCoordinateCoder;
//# sourceMappingURL=allDayEventCoordinateCoder.js.map